import { useState } from 'react';
import type { KeyboardEvent } from 'react';
import styles from './Interactive.module.css';

interface ShortAnswerProps {
  onSubmit: (answer: string) => void;
  disabled: boolean;
  showResult: boolean;
  isCorrect?: boolean;
  placeholder?: string;
}

export function ShortAnswer({ onSubmit, disabled, showResult, isCorrect, placeholder }: ShortAnswerProps) {
  const [value, setValue] = useState('');

  const handleSubmit = () => {
    if (disabled || !value.trim()) return;
    onSubmit(value.trim());
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleSubmit();
    }
  };

  const getInputClass = () => {
    let className = styles.textInput;
    if (showResult) {
      className += isCorrect ? ` ${styles.correct}` : ` ${styles.incorrect}`;
    }
    return className;
  };

  return (
    <div className={styles.inputContainer}>
      <input
        type="text"
        className={getInputClass()}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder={placeholder || "Type your answer..."}
        disabled={disabled}
        autoFocus
      />

      {!showResult && (
        <button
          className={styles.submitButton}
          onClick={handleSubmit}
          disabled={disabled || !value.trim()}
        >
          Submit Answer
        </button>
      )}
    </div>
  );
}
